import { action, noop } from '@reatom/framework'

import { blacklistCurrenciesLocalModel } from './reatom-blacklist-currencies-local'
import { blacklistCurrenciesRemoteModel } from './reatom-blacklist-currencies-remote'

export * from './blacklist-requests'
export * from './reatom-blacklist-currencies'
export * from './reatom-blacklist-currencies-local'
export * from './reatom-blacklist-currencies-table'

export const initializeBlacklistCurrencies = action(async (ctx) => {
  ctx.subscribe(blacklistCurrenciesRemoteModel, noop)
  ctx.subscribe(blacklistCurrenciesLocalModel, noop)
}, 'initializeBlacklistCurrencies')
